import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate } from 'react-router';

import { SectionTitle, CartBody, CartFooter, Form } from '../components';
import { createOrder } from '../redux/actions';
import { orderValidationSchema } from '../utils/formSchema';

export default function Checkout() {
  const {
    cartItems: { items },
  } = useSelector((state) => state);

  const dispatch = useDispatch();

  const fieldList = [
    { label: 'Email address', type: 'email', name: 'email' },
    { label: 'First Name', type: 'text', name: 'first_name' },
    { label: 'Last Name', type: 'text', name: 'last_name' },
    { label: 'Address', type: 'address', name: 'address' },
  ];

  const initialFieldValues = {
    email: '',
    first_name: '',
    last_name: '',
    address: '',
  };

  const handleCreateOrder = (values, setIsSubmitted) => {
    dispatch(createOrder(values, setIsSubmitted));
  };

  if (items.length <= 0) {
    return <Navigate to="/" />;
  }

  return (
    <div className="max-w-7xl mx-auto py-6 sm:px-6 px-8">
      <div className="md:grid md:grid-cols-2 md:gap-6">
        <div className="md:col-span-1">
          <SectionTitle label="Shipping Informtion" />
          <Form
            fieldList={fieldList}
            initialFieldValues={initialFieldValues}
            buttonText="Confirm Order"
            handleSubmit={handleCreateOrder}
            validationSchema={orderValidationSchema}
          />
        </div>
        <div className="md:col-span-1">
          <SectionTitle label="Order Summary" />
          <div
            className="mt-4 bg-stone-50 p-3 rounded-lg border-x
            border-y border-stone-100"
          >
            <CartBody />
            <CartFooter />
          </div>
        </div>
      </div>
    </div>
  );
}
